




















































































import { Component } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import AButton from '@/components/common/AButton.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { EyeIcon, EyeOffIcon, InfoIcon } from 'vue-feather-icons';
import { AuthApi } from '@/services/AuthApi';
import { SendResetPasswordModel } from 'admiral-core';
import FormError from '@/components/common/forms/FormError.vue';
import { FormMixin } from '@/mixins/FormMixin';
import LoginForm from '@/views/pages/auth/LoginForm.vue';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import ForgotPasswordForm from '@/views/pages/auth/ForgotPasswordForm.vue';

@Component({
  name: 'forgot-password',
  components: {
    ForgotPasswordForm,
    FormSubmit,
    LoginForm,
    FormError,
    AButton,
    EyeIcon,
    InfoIcon,
    EyeOffIcon,
  },
})
class ForgotPassword extends mixins(FormMixin, BaseMixin) {
  model = this.defaultModel();

  isLoading = false;

  sent = false;

  async handlePasswordReset(evt: Event) {
    evt.preventDefault();
    try {
      this.isLoading = true;

      await AuthApi.sendPasswordReset({
        email: this.model.email,
      });
      this.sent = true;
    } catch (e) {
      this.resetErrors();
      const apiErrors = this.exceptionErrors(e);

      this.addError(
        apiErrors['emailisNotEmpty'] || apiErrors['emailisEmail'],
        'email',
        'Bitte eine gültige E-Mail Adresse angeben.',
      );
    } finally {
      this.isLoading = false;
    }
  }

  defaultModel(): SendResetPasswordModel {
    return {
      email: '',
    };
  }
}
export default ForgotPassword;
